import { render } from "./ServiceRequisitions.vue?vue&type=template&id=58aac228&scoped=true"
import script from "./ServiceRequisitions.vue?vue&type=script&lang=js"
export * from "./ServiceRequisitions.vue?vue&type=script&lang=js"

import "./ServiceRequisitions.vue?vue&type=style&index=0&id=58aac228&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58aac228"]])

export default __exports__